"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortOfferItemsByType = sortOfferItemsByType;
const constants_1 = require("./constants");
function sortOfferItemsByType(a, b) {
    return constants_1.LESSON_TYPE_ORDER.indexOf(a.type) - constants_1.LESSON_TYPE_ORDER.indexOf(b.type);
}
